/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { MeControllerFindAllOrganisationDetailsQueryResponse, MeControllerFindAllOrganisationDetails400, MeControllerFindAllOrganisationDetails401, MeControllerFindAllOrganisationDetails404, MeControllerFindAllOrganisationDetails409, MeControllerFindAllOrganisationDetails500 } from "../types/MeControllerFindAllOrganisationDetails.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getMeControllerFindAllOrganisationDetailsUrl() {
  const res = { method: 'GET', url: `/api/me/organisation` as const }
  return res
}

/**
 * {@link /api/me/organisation}
 */
export async function meControllerFindAllOrganisationDetails(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MeControllerFindAllOrganisationDetailsQueryResponse, ResponseErrorConfig<MeControllerFindAllOrganisationDetails400 | MeControllerFindAllOrganisationDetails401 | MeControllerFindAllOrganisationDetails404 | MeControllerFindAllOrganisationDetails409 | MeControllerFindAllOrganisationDetails500>, unknown>({ method : "GET", url : getMeControllerFindAllOrganisationDetailsUrl().url.toString(), ... requestConfig })
  return res.data
}